<template>
    <div class="inner-page" ref="page">
        <div class="heads">
            <img src="../../assets/backTwo.jpg">
            <h1>戏苑百家</h1>
        </div>
        <div class="mainBox">
                <a href="http://wap.china1904.com/wx/xySong?iab=ba00f82b81d6714c0181d67185c50000&icd=ba00f82b81d6714c0181d6726adc01cc">
                    <img src="../../assets/xybjOne.jpg" >
                </a>
                <a href="http://wap.china1904.com/wx/xySong?iab=ba00f82b81d6714c0181d67277ca01e8&icd=ba00f82b81d6714c0181d6735ad2037c">
                    <img src="../../assets/xybjTwo.jpg">
                </a>

                <a href="http://wap.china1904.com/wx/xySong?iab=ba00f82b81d6714c0181d673ef39046e&icd=ba00f82b81d6714c0181d674877e0581">
                    <img src="../../assets/xybjThree.jpg">
                </a>
                <a href="http://wap.china1904.com/wx/xySong?iab=ba00f82b81d6714c0181d6736cf10392&icd=ba00f82b81d6714c0181d673e2860453">
                    <img src="../../assets/xybjFour.jpg">
                </a>
            <a href="http://wap.china1904.com/wx/xySong?iab=ba00f82b81d6714c0181d674920a0597&icd=ba00f82b81d6714c0181d674e91c0640">
                <img src="../../assets/xybj5.jpg">
            </a>

        </div>
        <div class="foots">
            <img src="../../assets/backOne.jpg">
        </div>
    </div>
</template>

<script>
    export default {
        name: "sortIndex"
    }
</script>

<style scoped lang="scss">

    .inner-page{
        background-color: #EDE5D5;
        .heads{
            width: 100%;
            height: 100%;
            position: relative;
            img{
                width: 100%;
            }
            h1{
                position: absolute;
                left: 50%;
                top: 35%;
                transform: translate(-50%,-50%);
                font-size: 24px;
                letter-spacing: 5px;
            }
        }
        .mainBox{
            width: auto;
            height: 100%;
            overflow-y: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            padding:  20px 10px;
            margin-bottom: 64px;
            a{
                display: block;
                overflow-y: hidden;
                width: 165px;
                padding: 0 6px;

            }
            img{
                width:100%;
                float: left;
                margin-bottom: 20px;
            }
        }
        .foots{
            position: fixed;
            bottom: -3px;
            left: 0;
        }


    }

</style>
